export default {
  name: "delete-sheba-card",
  components: {},
  props: {
    shebaData: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    handleDialog() {
      this.$emit("confirmDeleteAddress", false, true);
      // this.dialog = true;
    }
  }
};
